import {Canvas2Video} from "canvas2video";
import {FitUtil} from "./common/FitUtil";

export class VideoCapture {
  constructor() {
    if (FitUtil.isSafari()) {
      this.format = 'mp4'
    } else {
      this.format = 'webm'
    }
  }

  async startRecord() {
    const canvas = document.querySelector("#camera-canvas")
    console.log('startRecord', canvas.crossOrigin)
    canvas.crossOrigin = "Anonymous";

    this.canvas2videoInstance = new Canvas2Video({
      canvas,
      outVideoType: this.format,
      mimeType: `video/${this.format}`,
      workerOptions: {
        corePath: './static/ffmpeg-core.min.js'
      }
    });
    this.canvas2videoInstance.startRecord();

    this.canvas2videoInstance
        .getStreamURL()
        .then((url) => {
          console.log('url', url)
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.download = `web-fit.${this.format}`;
          a.href = url;
          a.click();
          a.remove();
        })
        .catch((err) => console.error(err));
  }

  async stopRecord() {
    console.log('stopRecord')
    this.canvas2videoInstance.stopRecord();
    // const url = await this.canvas2videoInstance.getStreamURL()
    // console.log('stopRecord', url)
    // setTimeout(() => {
    //   URL.revokeObjectURL(url);
    // }, 1E4);
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoCapture.js